<template>
  <div>
    <home-header />
    <div class="content page-width">
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-2">
          <ul class="centerli">
            <li>
              <router-link
                to="/degreemodule/degreeinfo"
                active-class="active"
                exact
                >学位外语免考认定</router-link
              >
            </li>
            <li>
              <router-link tag="a" to="" @click.native="handleExternalLink()"
                >学位外语考试报名</router-link
              >
            </li>
            <li>
              <router-link tag="a" to="" @click.native="handlePrintTick()"
                >打印准考证</router-link
              >
            </li>
            <li v-if="$store.state.homeObj.show_degree_apply === '1'">
              <router-link
                to="/personalcenters/degreeApplication"
                active-class="active"
                >学位申请</router-link
              >
            </li>

            <li v-if="$store.state.homeObj.show_degree_exam === '1'">
              <router-link tag="a" to="" @click.native="handleGetPaperList()"
                >考前测试</router-link
              >
            </li>
          </ul>
        </div>
        <div class="col-md-10">
          <router-view />
        </div>
      </div>
      <ul>
        <li></li>
      </ul>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import InsidePageBannar from "@/common/components/InsidePageBannar";
import InsidePageLeft from "@/common/components/InsidePageLeft";
import Foot from "@/common/components/Foot";
import Fade from "@/common/fade/FadeAnimation";
import MajorList from "./components/MajorList";
import SecuritySetting from "./components/SecuritySetting";
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "PersonalCenters",
  components: {
    HomeHeader,
    InsidePageBannar,
    Foot,
    MajorList,
    InsidePageLeft,
    Fade,
    SecuritySetting,
  },
  data: function () {
    return {
      arrs: [],
      sex: true,
    };
  },
  methods: {
    //跳转报名
    handleExternalLink() {
      this.axios.get(`/biz/degree/quick/wyksbm`).then((res) => {
        if (res.code === 200) {
          window.open(res.result.url, "_blank");
        }
      });
    },

    //获取列表接口
    async handleGetPaperList() {
      try {
        const res = await this.axios.get(
          `/degree/stuDegree/examList`
        );
        this.$router.push({
          path: "/personalcenters/exampaperlist",
          query: {
            paperList: JSON.stringify(res.result),
          },
        });
      } catch (error) {
        console.log(error);
      }
    },

    handlePrintTick() {
      this.axios.get(`/biz/degree/quick/wyksbm?path=showPrint`).then((res) => {
        if (res.code === 200) {
          window.open(res.result.url, "_blank");
        }
      });
    },
    getDetailInfo() {
      // axios.get('http://localhost:8080/static/mock/index.json').then(this.handleGetDataSucc)
    },
    handleGetDataSucc(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.arrs = data.course;
      }
    },
  },
  created() {},
  mounted() {
    this.getDetailInfo();
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;
}

.content {
  margin-top: 30px;
  background: #fff;
  padding: 28px;
  margin-bottom: 30px;
  min-height: 500px;

  .col-md-2 {
    min-height: 500px;
    border-right: 3px solid #edeff5;
    text-align: center;

    .active {
      background: $bgColor;
      color: #fff;
    }
  }
}

.centerli {
  background: $bgcontent;
  border-radius: 10px;
  padding-bottom: 30px;
  overflow: hidden;
  padding-top: 20px;

  .centerli-top {
    padding: 15px 0;
    font-size: 18px;
    color: $bgColor;
    font-weight: bold;
  }

  li {
    margin: 0px 10px;

    a {
      display: inline-block;
      width: 100%;
      padding: 15px 0;
      border-bottom: 1px solid #eaeaea;
      color: #999;
    }
  }
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
  margin-top: 20px;

  .grade {
    font-size: 15px;
    margin-left: 15px;
    color: #666;
  }
}

.personalimg {
  img {
    width: 112px;
    height: 125px;
  }
}

.mymajor {
  color: #999;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/DegreeModuleIndex.vue